import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./menuButton.styles";
export function MenuButton({ isSelected, text, onClick, }) {
    return (_jsx(S.Layout, { "$isSelected": isSelected, onClick: onClick, children: text }));
}
